import { User } from '@app/core/interfaces';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from './auth.reducer';
import { State } from './auth.reducer';

export const selectAuthState = createFeatureSelector<fromAuth.State>(
  fromAuth.authFeatureKey
);

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (authState: fromAuth.State): boolean => authState.isAuthenticated
);

export const selectUser = createSelector(
  selectAuthState,
  (authState: State): User | null => authState.user
);

export const selectUserRole = createSelector(
  selectUser,
  (user: User | null): string => user?.role ? user?.role : ''
);
